module.exports = __webpack_public_path__ + "media/Video 102.e9fb492e.mp4";